import { render, staticRenderFns } from "./redeemEmail.vue?vue&type=template&id=18ba949c&scoped=true"
import script from "./redeemEmail.vue?vue&type=script&lang=js"
export * from "./redeemEmail.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "18ba949c",
  null
  
)

export default component.exports